const bad_food = `Asunto: Problema con los nuggets de pollo que compré
Estimado gerente de tienda,
Quiero contarles algo malo que sucedió hoy cuando compré nuggets de pollo en su tienda.
Cuando los cociné para la cena, no olían bien y se sentían raros.
Cuando miré más de cerca, algunas partes todavía no estaban cocidas a pesar de que seguí las instrucciones.
Esto me entristeció mucho y me preocupó por enfermarme por comer alimentos no cocinados.
Normalmente confío en su tienda, pero ahora no estoy tan seguro de qué tan segura es su comida.
Por favor investigue esto y corríjalo para que no vuelva a suceder.
Me gustaría que me devolvieran el dinero por los nuggets de pollo en mal estado.
También debes comprobar cómo preparas la comida para asegurarte de que esto no vuelva a suceder.
Espero que puedas hacer algo al respecto y hacerme confiar nuevamente en tu tienda.
Sinceramente,`;
export default bad_food;
